import { createSlice } from '@reduxjs/toolkit';
import { logout } from '../auth';

const initialState = {
  qrAttendanceCounts: {},
};

const classroomAttendanceSlice = createSlice({
  name: 'classroomAttendance',
  initialState,
  reducers: {
    setQrAttendanceCount: (state, action) => {
      const sessionId = action.payload?.sessionId;

      if (!sessionId) return;

      state.qrAttendanceCounts[sessionId] = {
        sessionId,
        unitId: action.payload?.unitId,
        attendanceAction: action.payload?.attendanceAction,
        attendanceCount: action.payload?.attendanceCount,
        updatedAt: action.payload?.updatedAt || Date.now(),
      };
    },
    clearQrAttendanceCount: (state, action) => {
      const sessionId = action.payload;

      if (sessionId) {
        delete state.qrAttendanceCounts[sessionId];
        return;
      }

      state.qrAttendanceCounts = {};
    },
  },
  extraReducers: {
    [logout]: () => initialState,
  },
});

export const getQrAttendanceCount = (sessionId) => (state) =>
  state.classroomAttendance.qrAttendanceCounts?.[sessionId]?.attendanceCount;

export const getQrAttendanceCountUpdatedAt = (sessionId) => (state) =>
  state.classroomAttendance.qrAttendanceCounts?.[sessionId]?.updatedAt;

export const { setQrAttendanceCount, clearQrAttendanceCount } =
  classroomAttendanceSlice.actions;

export default classroomAttendanceSlice.reducer;
